<div class="membership-page-header">
  <div class="page-title" data-cy="membership-title">Membership</div>
  @if (showAddUser) {
    <div class="find-user-container">
      <app-input-autocomplete #findUser
        placeholder="Find a User"
        baseCypressTag="roles-management-add-user"
        [resultsFunction]="searchUsersWithNoRoles"
        [resultFormatter]="typeahead.inputTextFirstNameLastNameUsernameFormatter"
        [inputFormatter]="typeahead.inputTextFirstNameLastNameUsernameFormatter"
        (keydown.enter)="addUserToTable()"
        (inputValueChange)="updateUserInputValue($event)"
        [hasLabel]="false">
      </app-input-autocomplete>
      <button class="btn-secondary add-user"
        (click)=addUserToTable()
        [disabled]="disableButton()"
      data-cy="roles-management-add-user-button">Add user</button>
    </div>
  }
</div>

<app-users-table
  [context]="state.context"
[addUserToTable]="userToAdd"></app-users-table>


